<template>
  <div class="sent-for-approval-content popup">
    <a class="close-x" @click="closePopup">
      <img class="close-icon" src="@/assets/images/close_icon.svg" alt="">
    </a>
    <h2 class="title">
      <span>{{ $t("APPROVAL_POPUP_TEXT") }}</span>
      <span>{{'"' +  $t("CONTENT_FOR_APPROVAL") + '"' }}</span>
    </h2>
    <div class="sent-animation">
      <img src="@/assets/images/send-green-big.svg" class="icon" alt="">
    </div>
    <div class="buttons-wrap">
      <button class="common-button cancel-button" @click="closePopup">
        {{ $t("CLOSE") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sent-for-approval-popup',
  methods: {
    closePopup () {
      this.$emit('close-popup')
    }
  }
}
</script>

<style >

</style>
